// AUTO-GENERATED
//
// This code was automatically generated.
// It should not be modified by hand. Make changes to template files located at
// `generated/frontend-events`, then re-generate this file with `tracking-gen`.

type ResultType = [string, object]

/**
 * Loading Time
 * App Ready for User Interaction
 */
export type TrackLoadingTimeAppReadyForUserInteractionType = {
  deltaSeconds: string
  screen?: string
}

export const trackLoadingTimeAppReadyForUserInteractionPayload = ({
  deltaSeconds,
  screen,
}: TrackLoadingTimeAppReadyForUserInteractionType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Loading Time',
    event_description: 'App Ready for User Interaction',
    platforms: 'web',
    object: 'Time',
    action: 'Analysis',
    object_name: 'loadingTimeAppReady',
    delta_seconds: deltaSeconds,
    screen,
  }

  if (!screen) {
    delete payload.screen
  }

  return ['Time Analysis', payload]
}

/**
 * OAuth Flow
 * OAuth Event Occurred
 */
export enum OAuthFlowOAuthEventOccurredType {
  'Login_page_landed' = 'login_page_landed',
  'Login_button_clicked' = 'login_button_clicked',
  'Mfa_page_landed' = 'mfa_page_landed',
  'Mfa_button_clicked' = 'mfa_button_clicked',
  'Authorization_page_landed' = 'authorization_page_landed',
  'Authorization_button_clicked' = 'authorization_button_clicked',
}

export type TrackOAuthFlowOAuthEventOccurredType = {
  screen: string
  type: OAuthFlowOAuthEventOccurredType
  oauthAppId?: string
  oauthAppName?: string
  oauthAppClientId?: string
  oauthAppClientName?: string
}

export const trackOAuthFlowOAuthEventOccurredPayload = ({
  screen,
  type,
  oauthAppId,
  oauthAppName,
  oauthAppClientId,
  oauthAppClientName,
}: TrackOAuthFlowOAuthEventOccurredType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'OAuth Flow',
    event_description: 'OAuth Event Occurred',
    platforms: 'web',
    object: 'Event',
    action: 'Occurred',
    object_name: 'oAuthFlow',
    screen,
    type,
    oauth_app_id: oauthAppId,
    oauth_app_name: oauthAppName,
    oauth_app_client_id: oauthAppClientId,
    oauth_app_client_name: oauthAppClientName,
  }

  if (!oauthAppId) {
    delete payload.oauth_app_id
  }

  if (!oauthAppName) {
    delete payload.oauth_app_name
  }

  if (!oauthAppClientId) {
    delete payload.oauth_app_client_id
  }

  if (!oauthAppClientName) {
    delete payload.oauth_app_client_name
  }

  return ['Event Occurred', payload]
}

/**
 * Sign In With Apple
 * Button tapped
 */
export enum SignInWithAppleButtonTappedCta_title {
  'SignUp' = 'signUp',
  'SignIn' = 'signIn',
  'ContinueWithApple' = 'continueWithApple',
}

export type TrackSignInWithAppleButtonTappedType = {
  screen: string
  ctaTitle: SignInWithAppleButtonTappedCta_title
}

export const trackSignInWithAppleButtonTappedPayload = ({
  screen,
  ctaTitle,
}: TrackSignInWithAppleButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Sign In With Apple',
    event_description: 'Button tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'signInWithAppleButton',
    screen,
    cta_title: ctaTitle,
  }

  return ['Button Tapped', payload]
}

/**
 * Sign In With Apple
 * Button Viewed
 */
export enum SignInWithAppleButtonViewedCta_title {
  'SignUp' = 'signUp',
  'SignIn' = 'signIn',
  'ContinueWithApple' = 'continueWithApple',
}

export type TrackSignInWithAppleButtonViewedType = {
  screen: string
  ctaTitle: SignInWithAppleButtonViewedCta_title
}

export const trackSignInWithAppleButtonViewedPayload = ({
  screen,
  ctaTitle,
}: TrackSignInWithAppleButtonViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Sign In With Apple',
    event_description: 'Button Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'signInWithAppleButtonContainer',
    screen,
    cta_title: ctaTitle,
  }

  return ['Container Viewed', payload]
}

/**
 * Sign In With Apple
 * Account Exists Modal Viewed
 */
export type TrackSignInWithAppleAccountExistsModalViewedType = {
  screen: string
}

export const trackSignInWithAppleAccountExistsModalViewedPayload = ({
  screen,
}: TrackSignInWithAppleAccountExistsModalViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Sign In With Apple',
    event_description: 'Account Exists Modal Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'registrationAppleSSOExists',
    screen,
  }

  return ['Container Viewed', payload]
}

/**
 * Sign In With Apple
 * Account Exists Modal Dismissed
 */
export type TrackSignInWithAppleAccountExistsModalDismissedType = {
  screen: string
}

export const trackSignInWithAppleAccountExistsModalDismissedPayload = ({
  screen,
}: TrackSignInWithAppleAccountExistsModalDismissedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Sign In With Apple',
    event_description: 'Account Exists Modal Dismissed',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationAppleSSOExistsDismissed',
    screen,
  }

  return ['Button Tapped', payload]
}

/**
 * Sign In With Apple
 * Account Suspended Modal Viewed
 */
export type TrackSignInWithAppleAccountSuspendedModalViewedType = {
  screen: string
}

export const trackSignInWithAppleAccountSuspendedModalViewedPayload = ({
  screen,
}: TrackSignInWithAppleAccountSuspendedModalViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Sign In With Apple',
    event_description: 'Account Suspended Modal Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'registrationAppleSSOAccountSuspended',
    screen,
  }

  return ['Container Viewed', payload]
}

/**
 * Sign In With Apple
 * Account Suspended Modal Button Tapped
 */
export type TrackSignInWithAppleAccountSuspendedModalButtonTappedType = {
  screen: string
  ctaTitle: string
}

export const trackSignInWithAppleAccountSuspendedModalButtonTappedPayload = ({
  screen,
  ctaTitle,
}: TrackSignInWithAppleAccountSuspendedModalButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Sign In With Apple',
    event_description: 'Account Suspended Modal Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationAppleSSOAccountSuspendedCta',
    screen,
    cta_title: ctaTitle,
  }

  return ['Button Tapped', payload]
}
